import { Site } from "@libry-content/types";

export const getPlausibleDashboardUrl = (site: Pick<Site, "domain">) =>
  `https://plausible.io/${site.domain?.replace("www.", "")}`;
